import * as React from "react";
import type { SVGProps } from "react";
const SvgSmartUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={20}
    fill="none"
    viewBox="0 0 18 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.121 4.121 13.88 1.88A3 3 0 0 0 11.757 1H4a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6.243a3 3 0 0 0-.879-2.122"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17 6.5h-3.5a2 2 0 0 1-2-2V1M6.75 12.25 9 10l2.25 2.25M8.995 15v-5"
    />
  </svg>
);
export default SvgSmartUpload;
